import React from 'react';

import styled, { css } from 'styled-components';

import { LazyLoadImage } from 'react-lazy-load-image-component';

const ImageOneUp = ({ block, className }) => {

  return (
    <Container className={className} focalPoint={block.image[0].focalPoint} >
      <LazyLoadImage src={block.image[0].url} />
    </Container>
  )
};


export default ImageOneUp;

const Container = styled.section`
  display: flex;
  justify-content: center;
  margin: 3em 0;
  img {
    width: 90%;
    height: auto;
    max-height: 60vh;
    object-fit: contain;
    display: block;
    ${( { focalPoint } ) =>
    focalPoint &&
      css`
        object-position: ${focalPoint[0] * 100 + '%'} ${focalPoint[1] * 100 + '%'};
      `
    };
  }
`;

const StyledImage = styled(LazyLoadImage)`

`;